let $ = jQuery,
	ticker, phone, messages;

import "inputmask/dist/jquery.inputmask.bundle";

$( document ).ready(
	function() {
		if ( typeof stm_lms_sign_in !== 'undefined' ) {
			messages = stm_lms_sign_in.messages;
		}

		$( '[data-form]' ).on(
			'click',
			function() {
				let $this = $( this ),
					$id   = $this.data( 'form' );

				$this.parents( '.ms-child-form' ).hide();
				$( $id, '.stm-lms-form-submit' ).fadeIn();
			}
		);

		$( document ).on(
			'click',
			'.ms-child-form__link',
			function( e ) {
				e.preventDefault();
				e.stopPropagation();
				window.location.reload();
			}
		);

		let inputs = $( ".ms-child-form__form-input_phone" );

		if ( inputs.length ) {
			inputs.each(
				function () {
					let $input = $( this ),
					selector   = document.getElementById( $input.attr( 'id' ) );

					let im = new Inputmask( "\\+\\9\\98 (##) ###-##-##" );
					im.mask( selector );
				}
			)
		}

		$( '.ms-child-form__form' ).on(
			'submit',
			function ( e ) {
				e.preventDefault();

				request( this );
			}
		);

		let sign_up_forms = $( '#verification, #sign-in-set-info' );

		$( '[data-close]', sign_up_forms ).on(
			'click',
			function () {
				let wrapper = $( this ).parents( '.stm-lms-modal-form' );

				ticker.stop();

				wrapper.attr( 'aria-hidden', true ).removeClass( 'stm-lms-modal-form-show' );
				$( '.ms-child-form__timer', wrapper ).text( '01:59' );
			}
		);

		sign_up_forms.on(
			'click',
			function ( e ) {
				if ( ! $( e.target ).closest( '.stm-lms-form__content' ).length ) {
					ticker.stop();

					$( this ).attr( 'aria-hidden', true ).removeClass( 'stm-lms-modal-form-show' );
					$( '.ms-child-form__timer', this ).text( '01:59' );
				}
			}
		);
	}
);

/**
 * Self-adjusting interval to account for drifting
 *
 * @param {function} workFunc  Callback containing the work to be done
 *                             for each interval
 * @param {int}      interval  Interval speed (in milliseconds)
 * @param {function} errorFunc (Optional) Callback to run if the drift
 *                             exceeds interval
 */
function AdjustingInterval( workFunc, interval, errorFunc ) {
	let that                    = this,
		expected, timeout, stop = false;

	this.interval = interval;

	this.start = function() {
		expected = Date.now() + this.interval;
		timeout  = setTimeout( step, this.interval );
	}

	this.stop = function() {
		clearTimeout( timeout );
		stop = true;
	}

	this.to = function ( second ) {
		let sec_num = parseInt( second, 10 ),
			hours   = Math.floor( sec_num / 3600 ),
			minutes = Math.floor( (sec_num - (hours * 3600)) / 60 ),
			seconds = sec_num - (hours * 3600) - (minutes * 60);

		if ( minutes < 10 ) {
			minutes = "0" + minutes;
		}

		if ( seconds < 10 ) {
			seconds = "0" + seconds;
		}

		return minutes + ':' + seconds;
	}

	function step() {
		if ( stop ) {
			return;
		}

		let drift = Date.now() - expected;
		if ( drift > that.interval ) {
			// You could have some default stuff here too...
			if (errorFunc) {
				errorFunc();
			}
		}
		workFunc( that );
		expected += that.interval;
		timeout   = setTimeout( step, Math.max( 0, that.interval - drift ) );
	}
}

function timer() {
	let justSomeNumber = 0;

	// Define the work to be done
	let doWork = function( that ) {
		let time = 120 - ++justSomeNumber;

		if ( time >= 0 ) {
			$( '.ms-child-form__timer' ).text( that.to( time ) )
		} else {
			that.stop();
		}
	};

	// Define what to do if something goes wrong
	let doError = function() {
		console.warn( 'The drift exceeded the interval.' );
	};

	// (The third argument is optional)
	return new AdjustingInterval( doWork, 1000, doError );
}

function request( form ) {
	let data     = $( form ).serializeArray(),
		$wrapper = $( form ).parents( '.ms-child-form' ),
		form_id  = $wrapper.attr( 'id' ),
		formData = new FormData();

	if ( data.length ) {
		data.forEach(
			function ( item ) {
				formData.append( item.name, item.value );

				if ( 'phone' === item.name ) {
					phone = item.value;
				}
			}
		);

		let button  = $( '.ms-child-form__form-btn', form ),
			message = $( '.ms-child-form__message', form );

		if ( 'verification' === form_id ) {
			let code = '';
			for ( let increment = 1; increment < 7; increment++ ) {
				code += String( $( 'input#secret-' + increment, form ).val() );
				formData.delete( 'secret-' + increment );
			}

			formData.append( 'code', code );
		}

		if ( [ 'verification', 'sign-in-set-info', 'forgot-password-two' ].includes( form_id ) ) {
			formData.append( 'phone', phone );
		}

		$.ajax(
			{
				url: stm_lms_ajaxurl,
				type: 'POST',
				processData: false,
				contentType: false,
				context: form,
				data: formData,
				beforeSend: function() {
					message.removeClass( 'error success' ).text( '' );
					button.addClass( 'loading' ).prop( 'disabled', true );
				},
				complete: function( data ) {
					let response = data[ 'responseJSON' ];

					button.removeClass( 'loading' ).prop( 'disabled', false );

					if ( 'error' === response.status ) {
						message.addClass( response.status ).html( response.message );
					} else if ( 'success' === response.status ) {
						let verificationModal = $( '#verification' );

						message.addClass( response.status ).html( response.message );

						if ( 'sign-up' === form_id ) {
							$wrapper.attr( 'aria-hidden', true ).removeClass( 'stm-lms-modal-form-show' );
							verificationModal.attr( 'aria-hidden', false ).addClass( 'stm-lms-modal-form-show' );
							$( 'input[name="type"]', verificationModal ).val( 'sign-up' );

							ticker = timer();
							ticker.start();
						} else if ( 'verification' === form_id ) {
							$wrapper.attr( 'aria-hidden', true ).removeClass( 'stm-lms-modal-form-show' );
							$( '#sign-in-set-info' ).attr( 'aria-hidden', false ).addClass( 'stm-lms-modal-form-show' );
						} else if ( 'sign-in-set-info' === form_id && response.user_page ) {
							window.location = response.user_page;
						} else if ( 'sign-in' === form_id ) {
							window.location.reload();
						} else if ( 'forgot-password' === form_id ) {
							$wrapper.attr( 'aria-hidden', true ).removeClass( 'stm-lms-modal-form-show' );
							verificationModal.attr( 'aria-hidden', false ).addClass( 'stm-lms-modal-form-show' );
							$( 'input[name="type"]', verificationModal ).val( 'forgot-password' );

							ticker = timer();
							ticker.start();
						} else if ( 'forgot-password-two' === form_id ) {
							window.location = response.user_page;
						}
					} else if ( 'forgot-password' === response.status && 'verification' === form_id ) {
						$wrapper.attr( 'aria-hidden', true ).removeClass( 'stm-lms-modal-form-show' );
						$( '#forgot-password-two' ).attr( 'aria-hidden', false ).addClass( 'stm-lms-modal-form-show' );
					}
				},
				error: function ( data ) {
					if ( 403 === data.status ) {
						message.addClass( 'error' ).html( messages.error );
					}
				}
			}
		);
	}
}

// $( window ).on(
// 	'load',
// 	function () {
// 		Vue.use( VueAxios, Axios );
// 		Vue.component( 'codeinput', CodeInput );
//
// 		$( '.stm-lms-form-submit:not(.loaded)' ).each(
// 			function () {
// 				$( this ).addClass( 'loaded' );
//
// 				Vue.component(
// 					"timer",
// 					{
// 						props: {
// 							value: {
// 								default: 600
// 									}
// 									},
// 									data() {
// 										return {
// 											time: 10, //in seconds
// 											timer: null,
// 										}
// 						},
// 						methods: {
// 							decrementOrAlert() {
// 								if ( this.time > 0 ) {
// 									this.time--
// 									return
// 								}
//
// 								alert( "Time is up!" )
// 								clearInterval( this.timer )
// 							}
// 						},
// 						computed: {
// 							timeLeft() {
// 								return `${this.minutes}:${this.seconds}`;
// 							},
// 							minutes() {
// 								return String( Math.floor( this.time / 60 ) ).padStart( 2, '0' )
// 							},
// 							seconds() {
// 								return String( this.time % 60 ).padStart( 2, '0' )
// 							}
// 						},
// 						created() {
// 							this.time  = this.value
// 							this.timer = setInterval( this.decrementOrAlert, 1000 )
// 						},
// 						template: '<span>{{ timeLeft }}</span>'
// 					}
// 				);
//
// 				new Vue(
// 					{
// 						el: this, // selector
// 						components: {
// 							MaskedInput
// 						},
// 						data: function () {
// 							return {
// 								vue_loaded: true,
// 								loading: false,
// 								phone: '',
// 								email: '',
// 								phone_code: '998',
// 								code: '',
// 								enter_password: '',
// 								enter_name: '',
// 								password_re: '',
// 								register: false,
// 								sign_in: false,
// 								password: false,
// 								limit: false,
// 								phone_required: false,
// 								sent_limit: false,
// 								resend: false,
// 								message: '',
// 								status: '',
// 								position: '',
// 								object: {},
// 								disabled: false,
// 								times: '02:00',
// 								fields: [...Array( 6 ).keys()],
// 								forms: {
// 									prev: '',
// 									next: '',
// 									current: '',
// 									verify: false,
// 									register: false,
// 								},
// 								key_code: {
// 									backspace: 8,
// 									delete: 46,
// 									left: 37,
// 									up: 38,
// 									right: 39,
// 									down: 40,
// 								}
// 							};
// 						},
// 						mounted: function () {
// 							let vm = this,
// 							object = {};
//
// 							if ( typeof stm_lms_sign_in !== 'undefined' ) {
// 								object = stm_lms_sign_in;
// 							}
//
// 							vm.object = object;
//
// 							if ( vm.object.position !== undefined ) {
// 								vm.position = vm.object.position;
// 							}
//
// 							vm.forms.current = 'register';
// 							vm.switchForms();
// 						},
// 						methods: {
// 							switchForms: function ( back = false ) {
// 								let vm = this;
//
// 								if ( 'register' === vm.forms.prev && back ) {
// 									vm.forms.register = true;
// 								}
//
// 								if ( 'verify' === vm.forms.next && ! back ) {
// 									vm.forms.verify = true;
// 								}
//
// 								if ( 'register' === vm.forms.current ) {
// 									vm.forms.register = true;
// 								}
// 							},
// 							onChange( v ) {
// 								console.log( "onChange ", v );
// 							},
// 							onComplete( v ) {
// 								console.log( "onComplete ", v );
// 							},
// 							signUp: function () {
// 								let vm = this,
// 								url    = stm_lms_ajaxurl + '?action=' + vm.object.actions.sign_up + '&_ajax_nonce=' + vm.object.nonces.sign_up;
//
// 								vm.status  = '';
// 								vm.message = '';
// 								vm.loading = true;
//
// 								let data = {
// 									'phone': vm.phone
// 								};
//
// 								vm.$http.post( url, data ).then(
// 									function (response) {
// 										vm.status  = response.data['status'];
// 										vm.message = response.data['message'];
// 										vm.loading = false;
//
// 										if ( vm.status === 'success' ) {
// 											vm.forms.next = 'verify';
// 											vm.forms.prev = 'register'
//
// 											vm.switchForms();
// 										}
// 									}
// 								);
// 							},
// 							formSubmit: function () {
// 								let vm = this;
//
// 								vm.status  = '';
// 								vm.message = '';
//
// 								if (vm.verify && ! vm.resend) {
// 									vm.verification();
// 								} else if ( vm.password ) {
// 									vm.create_account();
// 								} else {
// 									vm.signIn();
// 								}
// 							},
// 							signIn: function () {
// 								let vm = this,
// 								url    = stm_lms_ajaxurl + '?action=' + vm.object.actions.sign_in + '&_ajax_nonce=' + vm.object.nonces.sign_in;
//
// 								vm.loading = true;
// 								vm.message = '';
//
// 								let data = {
// 									'email': vm.email,
// 									'phone': vm.phone,
// 									'password': vm.enter_password,
// 									'limit': vm.limit
// 								};
//
// 								vm.$http.post( url, data ).then(
// 									function (response) {
// 										vm.status  = response.data['status'];
// 										vm.message = response.data['message'];
// 										vm.loading = false;
//
// 										if (vm.status === 'success') {
// 											window.location.reload();
// 										} else if ( vm.status === 'password' ) {
// 											vm.password = true;
// 										} else if ( vm.status === 'limit' ) {
// 											vm.limit = true;
// 										} else if ( vm.status === 'phone_required' ) {
// 											vm.phone_required = true;
// 										} else if ( vm.status === 'sent_request_limit' ) {
// 											vm.limit      = false;
// 											vm.sent_limit = true;
// 										}
//
// 										vm.resend = false;
// 									}
// 								);
// 							},
// 							verification: function () {
// 								let vm = this,
// 								url    = stm_lms_ajaxurl + '?action=' + vm.object.actions.verification + '&_ajax_nonce=' + vm.object.nonces.verification;
//
// 								vm.loading = true;
// 								vm.message = '';
//
// 								let data = {
// 									'phone': vm.phone,
// 									'code': vm.code
// 								};
//
// 								vm.$http.post( url, data ).then(
// 									function (response) {
// 										vm.status  = response.data['status'];
// 										vm.message = response.data['message'];
// 										vm.loading = false;
//
// 										if (vm.status === 'success') {
// 											vm.password = true;
// 											vm.register = true;
// 											vm.verify   = false;
// 										}
// 									}
// 								);
// 							},
// 							create_account: function () {
// 								let vm = this,
// 								url    = stm_lms_ajaxurl + '?action=' + vm.object.actions.create_account + '&_ajax_nonce=' + vm.object.nonces.create_account;
//
// 								vm.loading = true;
// 								vm.message = '';
//
// 								let data = {
// 									'phone': vm.phone,
// 									'register': vm.register,
// 									'password': vm.enter_password,
// 									'name': vm.enter_name,
// 									'position': vm.object.position,
// 									'password_re': vm.password_re
// 								};
//
// 								vm.$http.post( url, data ).then(
// 									function (response) {
// 										vm.status  = response.data['status'];
// 										vm.message = response.data['message'];
// 										vm.loading = false;
//
// 										if ( vm.status === 'success' ) {
// 											vm.password = true;
// 											vm.register = false;
// 										}
//
// 										if ( response.data['user_page'] ) {
// 											window.location = response.data['user_page'];
// 										}
// 									}
// 								);
// 							}
// 						}
// 					}
// 				);
// 			}
// 		);
// 	}
// );
